module.exports = __webpack_public_path__ + "assets/img/404.b063438b.png";